"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LocalTrack_1 = __importDefault(require("./LocalTrack"));
const Track_1 = require("./Track");
class LocalAudioTrack extends LocalTrack_1.default {
    constructor(mediaTrack, name, constraints) {
        super(mediaTrack, Track_1.Track.Kind.Audio, name);
        this.constraints = constraints || {};
    }
}
exports.default = LocalAudioTrack;
//# sourceMappingURL=LocalAudioTrack.js.map